export default "__VITE_ASSET__BQM2IRQK__"